import React from 'react'
import PropTypes from 'prop-types'
import {Field, getIn} from 'formik'

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react'

const FormikFieldWrapper = ({
  label,
  placeholder,
  name,
  type,
  icon,
  children,
}) => {
  return (
    <Field name={name}>
      {({field, form: {touched, errors}}) => (
        <FormControl
          pb="sm"
          isInvalid={Boolean(getIn(touched, name) && getIn(errors, name))}
        >
          {label && (
            <FormLabel>
              <Text textStyle="body-copy-medium">{label}</Text>
            </FormLabel>
          )}
          {icon ? (
            <InputGroup size="lg">
              <InputLeftElement>{icon}</InputLeftElement>
              {children || (
                <Input
                  size="lg"
                  fontSize="base"
                  type={type}
                  name={field.name}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  value={field.value}
                  placeholder={placeholder}
                />
              )}
            </InputGroup>
          ) : (
            children || (
              <Input
                size="lg"
                fontSize="base"
                type={type}
                name={field.name}
                onChange={field.onChange}
                onBlur={field.onBlur}
                value={field.value}
                placeholder={placeholder}
              />
            )
          )}
          <FormErrorMessage justifyContent="end" textStyle="body-detail">
            <Text textStyle="body-detail">{getIn(errors, name)}</Text>
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

FormikFieldWrapper.defaultProps = {
  type: 'text',
  icon: null,
  label: null,
  children: null,
  placeholder: null,
}

FormikFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
  placeholder: PropTypes.string,
}

export default FormikFieldWrapper
